import { useContext } from "react";
import { AxiosContext } from "../../contexts/AxiosContext";

const useMSSP = () => {
  const {
    isMSSP,
    msspId,
    currentTenantId,
    switchTenant,
    rerenderKey,
    isAllTenants,
    setIsAllTenants,
    selectedTenantIds,
    setSelectedTenantIds,
    hasMultipleSelectedTenants,
  } = useContext(AxiosContext);

  return {
    isMSSP,
    msspId,
    currentTenantId,
    switchTenant,
    rerenderKey,
    isAllTenants,
    setIsAllTenants,
    selectedTenantIds,
    setSelectedTenantIds,
    hasMultipleSelectedTenants,
  };
};

export default useMSSP;
